module.exports = __webpack_public_path__ + "img/vista-1.021f758b.svg";